import { useCallback, useMemo, useState } from 'react';
import { useSideEffectListener } from '../useStreaming/useSideEffectListener';
export const useQuickReplySuggestions = _ref => {
  let {
    connection,
    conversationId
  } = _ref;
  const [receivedSuggestions, setReceivedSuggestions] = useState([]);
  const onSideEffect = useCallback((payload, event) => {
    const {
      userMessageId,
      tags
    } = payload;
    setReceivedSuggestions(prev => [...prev, {
      userMessageId,
      conversationId: event.conversationId,
      quickReplySuggestions: tags.quickReplies
    }]);
  }, []);
  useSideEffectListener({
    connection,
    onSideEffect,
    filter: {
      name: 'receivedTags'
    }
  });
  const quickReplySuggestions = useMemo(() => Object.fromEntries(receivedSuggestions.filter(suggestion => suggestion.conversationId === conversationId).filter(suggestion => suggestion.userMessageId).map(suggestion => [suggestion.userMessageId, suggestion.quickReplySuggestions])), [conversationId, receivedSuggestions]);
  return {
    quickReplySuggestions
  };
};
//# sourceMappingURL=useQuickReplySuggestions.js.map